import { render, staticRenderFns } from "./tableLayout.vue?vue&type=template&id=11fc0098&"
import script from "./tableLayout.vue?vue&type=script&lang=js&"
export * from "./tableLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports